
import { Vue, Component, Prop } from "vue-property-decorator";
import { Contractor_Staff_Note, User } from "@/generated/graphql";
import ResourceAvatarNew from "@/components/card/ResourceAvatarNew.vue";
import RouteNames from "@/entities/RouteNames";
import ColorIconContainer from "@/components/icons/ColorIconContainer.vue";
import MessageIcon from "@/components/icons/MessageIcon.vue";
import moment from "moment";

@Component({
    components: {
        ResourceAvatarNew,
        ColorIconContainer,
        MessageIcon
    }

})

export default class Notes extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Object, required: true }) readonly note!: Contractor_Staff_Note;


    get contractorInitials(): string {
        return `${this.note.contractor.user.given_name![0]}${this.note.contractor.user.family_name![0]}`;
    }

    get contractorFullName(): string {
        return `${this.note.contractor.user.given_name} ${this.note.contractor.user.family_name}`;
    }

    get jobTitle(): string {
        if (this.note.contractor.user.profile.job_title) {
            return this.note.contractor.user.profile.job_title;
        }
        for (let i = 0; i < this.note.contractor.user.user_profile_by_managements.length; i++) {
            const profileByManagement = this.note.contractor.user.user_profile_by_managements[i];
            if (profileByManagement.job_title) {
                return profileByManagement.job_title;
            }
        }
        return "";
    }

    formattedDate(date: string): string {
        if (date) {
            return new Date(date).toLocaleDateString('en-ca', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            });
        } else {
            return "n/a";
        }
    }

    formattedTime(dateTime: string): string {
        if (dateTime) {
            return moment(dateTime).format("hh:mm A");
        } else {
            return "n/a";
        }
    }

    message(): void {
        this.$router.push({
            name: RouteNames.INBOX,
            query: {
                recipientUserId: this.note.contractor.user.id,
            },
        });
    }

}

